import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import { tenantKeys } from "@/lib/queryKeys";
import { getTenantCurrent } from "@/services/authService";
import type { SpecialRegime } from "@/lib/taxOptions";

/**
 * The tenant's régimen especial de IVA, for surfaces that need to know which
 * tax rates to offer.
 *
 * Its own hook because three catalog forms and the invoice line all need the
 * same answer, and each fetching `/tenants/current` its own way is how they
 * end up disagreeing about which rates a tenant may pick. Shares the query
 * cache with every other consumer of the current tenant.
 */
export function useTenantSpecialRegime(): SpecialRegime | null {
  const { user } = useAuth();
  const { data: tenant } = useQuery({
    queryKey: tenantKeys.current(user?.tenantId ?? undefined),
    queryFn: getTenantCurrent,
    enabled: Boolean(user?.tenantId),
    staleTime: 60_000,
  });
  return (tenant?.specialRegime as SpecialRegime | null) ?? null;
}
